// RuleRow.jsx — single rule { field, op, value } with delete button
import React from 'react';
import { Button } from 'reactstrap';
import { X } from 'lucide-react';
import FieldPicker from './FieldPicker.jsx';
import OperatorPicker from './OperatorPicker.jsx';
import ValueInput from './ValueInput.jsx';
import { operatorsForField } from '../helpers/fieldCatalog.js';

const RuleRow = ({ rule, onChange, onRemove }) => {
  const updateField = (newField) => {
    // When field changes, reset op + value (operator list depends on type)
    const validOps = operatorsForField(newField).map(o => o.value);
    const stillValidOp = validOps.includes(rule.op) ? rule.op : null;
    onChange({ field: newField, op: stillValidOp, value: stillValidOp ? rule.value : undefined });
  };
  const updateOp = (newOp) => {
    onChange({ ...rule, op: newOp, value: undefined });
  };
  const updateValue = (newValue) => {
    onChange({ ...rule, value: newValue });
  };

  return (
    <div className="d-flex align-items-start mb-2" style={{ gap: '0.5rem' }}>
      <div style={{ flex: '1 1 200px', minWidth: 0 }}>
        <FieldPicker value={rule.field} onChange={updateField} />
      </div>
      <div style={{ flex: '0 0 160px' }}>
        <OperatorPicker fieldKey={rule.field} value={rule.op} onChange={updateOp} />
      </div>
      <div style={{ flex: '2 1 250px', minWidth: 0 }}>
        <ValueInput fieldKey={rule.field} op={rule.op} value={rule.value} onChange={updateValue} />
      </div>
      <Button color="link" size="sm" onClick={onRemove} className="text-muted" title="Remove rule">
        <X size={18} />
      </Button>
    </div>
  );
};

export default RuleRow;
